import React from 'react'
import { hasErrors } from './'
import PropTypes from 'prop-types'
import FormError from './FormError'

const StoreFinderInput = ({ field, form, children, ...props }) => {
  return (
    <div className="mb-6">
      <div className="flex items-stretch">
        <input
          {...field}
          {...props}
          value={field.value || ''}
          className={`w-full flex-1 py-4 px-6 text-lg rounded-l-lg bg-primary-lighter placeholder-black 
          ${
            hasErrors({ field, form })
              ? 'border border-error'
              : 'border border-transparent'
          }`}
        />
        {children}
      </div>
      {hasErrors({ field, form }) && (
        <FormError error={form.errors[field.name]} />
      )}
    </div>
  )
}

StoreFinderInput.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.string,
  }),
  errors: PropTypes.object,
  props: PropTypes.object,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
}

export default StoreFinderInput
